import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import type { Swiper } from 'swiper';
import type { SwiperOptions } from 'swiper/types/swiper-options';
import { register } from 'swiper/element/bundle';

register();

@Directive({
    selector: 'swiper-container[ftSwiper]',
    standalone: false
})
export class FtSwiperDirective implements AfterViewInit {
    @Input() config: SwiperOptions;

    swiper: Swiper;
    private swiperEl: any;

    constructor(elRef: ElementRef) {
        this.swiperEl = elRef.nativeElement;
    }

    ngAfterViewInit() {
        // Swiper 12 Element defaults eventsPrefix to 'swiper', so events fire as
        // 'swiperslidechange', 'swipertransitionend', etc. (Clearing the prefix
        // would make Swiper's internal 'touchmove' collide with the native DOM
        // event of the same name and crash Swiper's touch handler.)
        if (this.config) {
            Object.assign(this.swiperEl, this.config);
        }
        this.swiperEl.initialize();
        this.swiper = this.swiperEl.swiper;
    }

    slideNext(speed?: number) {
        this.swiper?.slideNext(speed);
    }

    slidePrev(speed?: number) {
        this.swiper?.slidePrev(speed);
    }

    slideTo(index: number, speed?: number) {
        this.swiper?.slideTo(index, speed);
    }
}
